var map = {
	"./date-format.de-CH.json": 964,
	"./date-format.de-DE.json": 965,
	"./date-format.en-CA.json": 966,
	"./date-format.en-GB.json": 967,
	"./date-format.en-IN.json": 968,
	"./date-format.en-ME.json": 969,
	"./date-format.en-US.json": 970,
	"./date-format.es-EM.json": 971,
	"./date-format.es-ES.json": 972,
	"./date-format.fr-BE.json": 973,
	"./date-format.fr-CA.json": 974,
	"./date-format.fr-CH.json": 975,
	"./date-format.nl-BE.json": 976,
	"./date-format.nl-NL.json": 977,
	"./date-format.pl-PL.json": 978,
	"./date-format.pt-BR.json": 979
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 963;